// src/components/Metrics.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Container, Row, Col, Table } from 'react-bootstrap';
import ReactPaginate from 'react-paginate';
import apinode from '../../services/apinode';

const Metrics = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [productsPerPage] = useState(10);

  useEffect(() => {
    apinode.get(`/anuncios/dados/${localStorage.idconta}`)
      .then(response => {
        setProducts(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Erro ao buscar dados do Mercado Livre:', error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Carregando...</div>;
  }

  // Calcular métricas
  const totalProducts = products.length;
  const totalSoldQuantity = products.reduce((acc, product) => acc + product.sold_quantity, 0);
  const averagePrice = (products.reduce((acc, product) => acc + product.price, 0) / totalProducts).toFixed(2);

  // Lógica de paginação
  const indexOfLastProduct = (currentPage + 1) * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const currentProducts = products.slice(indexOfFirstProduct, indexOfLastProduct);

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  return (
    <Container>
      <Row>
        <Col>
          <h1>Métricas dos Produtos</h1>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <h3>Total de Produtos: {totalProducts}</h3>
        </Col>
        <Col md={4}>
          <h3>Total de Quantidade Vendida: {totalSoldQuantity}</h3>
        </Col>
        <Col md={4}>
          <h3>Preço Médio: R${averagePrice}</h3>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>ID</th>
                <th>Nome</th>
                <th>Categoria</th>
                <th>Preço</th>
                <th>Quantidade Inicial</th>
                <th>Quantidade Disponível</th>
                <th>Quantidade Vendida</th>
                <th>Data de Criação</th>
                <th>Última Atualização</th>
              </tr>
            </thead>
            <tbody>
              {currentProducts.map(product => (
                <tr key={product.id}>
                  <td>{product.id}</td>
                  <td>{product.title}</td>
                  <td>{product.category}</td>
                  <td>R${product.price.toFixed(2)}</td>
                  <td>{product.initial_quantity}</td>
                  <td>{product.available_quantity}</td>
                  <td>{product.sold_quantity}</td>
                  <td>{new Date(product.date_created).toLocaleDateString()}</td>
                  <td>{new Date(product.last_updated).toLocaleDateString()}</td>
                </tr>
              ))}
            </tbody>
          </Table>
          <ReactPaginate
            previousLabel={"anterior"}
            nextLabel={"próximo"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={Math.ceil(products.length / productsPerPage)}
            marginPagesDisplayed={2}
            pageRangeDisplayed={5}
            onPageChange={handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default Metrics;
